<template>
  <v-app>
    <v-app-bar app color="#d11f49" dark>
      <div class="d-flex align-center">
        <v-img
          alt="LBC Logo"
          class="shrink mr-2"
          contain
          src="./assets/LBC logo.png"
          transition="scale-transition"
          width="40"
          @click="toHome"
        />

        <span class="headline font-weight-bold">LBC Branch</span>
      </div>

      <v-spacer></v-spacer>
      <!-- <v-btn color="info" to="/fileupload" depressed>
        <v-icon left>mdi-cloud-upload</v-icon>
        Upload file
      </v-btn> -->
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    HelloWorld
  },

  data: () => ({
    //
  }),
  methods: {
    toHome() {
      this.$router.push("/");
    }
  }
};
</script>
